import { RouterProvider } from 'atomic-router-react'
import { Pages } from '@/pages'
import { router } from './routing/router'
import { Styles } from './styles'
import { useUnit } from 'effector-react'
import { ThemeProvider } from '@mui/material'
import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { gtag } from '@/shared/constants'
import { AppContainer } from './container'
import { MuiTheme } from '@/shared/styles/mui'

const keysToInvalidate = [
  'currencyRates',
  'subscriptionPrices',
  'tasksList',
  'totalAccountValue',
  'hoursLeaderboard',
  'assetsLeaderboard',
  'gigiLeaderboard',
  'gamedLeaderboard',
]

export const App = () => {
  const path = useUnit(router.$path)
  ReactGA.initialize(gtag)

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname })
  }, [path])

  useEffect(() => {
    keysToInvalidate.forEach((cacheKey) => {
      try {
        localStorage.removeItem(cacheKey)
      } catch {
        console.log(`can not delete cache key ${cacheKey}`)
      }
    })
  }, [])

  return (
    <RouterProvider router={router}>
      <ThemeProvider theme={MuiTheme}>
        <Styles>
          <AppContainer>
            <Pages />
          </AppContainer>
        </Styles>
      </ThemeProvider>
    </RouterProvider>
  )
}
